import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { InvoiceStore, InvoiceState } from './invoice.store';

@Injectable({ providedIn: 'root' })
export class InvoiceQuery extends Query<InvoiceState> {
  constructor(protected override store: InvoiceStore) {
    super(store);
  }
}
